module.exports = __webpack_public_path__ + "static/media/05.2e6e1b28.jpg";